<div class="card">
    <div style="display: flex">
        <p-dialog header="Error" [(visible)]="errorOnUpdate" [maximizable]="false">
            <h4>
                {{uiErrorMessage}}
            </h4>
            <ng-template #footer>
                <button type="button" pButton class="p-button-secondary" (click)="errorOnUpdate = false"
                    label="OK"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Error" [(visible)]="showErrorDialog" [maximizable]="false">
            <h4>
                Cannot exceed 24 hours in a day.
            </h4>
            <ng-template #footer>
                <button type="button" pButton class="p-button-secondary"
                    (click)="showErrorDialog = false; onRowEditCancel(this.rowData)" label="OK"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Error" [(visible)]="showTimerOverlapDialog" [maximizable]="false">
            <h4>
                Cannot have overlapping timers.
            </h4>
            <ng-template #footer>
                <button type="button" pButton class="p-button-secondary"
                    (click)="showTimerOverlapDialog = false; onRowEditCancel(this.rowData)" label="OK"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div style="display: flex">
        <p-dialog header="Comment" [(visible)]="commentOnUpdate" [maximizable]="false" [closable]="false">
            <textarea rows="5" cols="30" pInputTextarea [(ngModel)]="this.comment" autoResize="autoResize"></textarea>
            <ng-template #footer>
                <button type="button" pButton class="p-button-secondary" (click)="addComment()"
                    label="Add Comment & Update" [disabled]="this.comment == null ? true : false"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div class="table-container">
        <div *ngIf="!showHistory" class="flex justify-content-start mb-3">
            <button pButton type="button" class="p-button-secondary" label="Start Timer" [disabled]="startTimerDisabled"
                (click)="startTimer()"></button>
            <button pButton type="button" class="p-button-secondary" label="Stop Timer" [disabled]="stopTimerDisabled"
                (click)="stopTimer()"></button>
        </div>

        <p-accordion [multiple]="true">
            <p-accordionTab *ngIf="!showHistory" [selected]="true" header="Task Timer">
                <p-table stripedRows #TimerTable [style]="{ 'max-width': '100%' }" [value]="timerList" scrollDirection="both"
                    [scrollable]="true" scrollHeight="40vh" dataKey="uniqueid" [(selection)]="selectedTask"
                    selectionMode="single" (onRowSelect)="rowSelected($event)" (onRowUnselect)="rowUnselected($event)">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="17" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available. Make sure web entry dates include today's date. </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th class="select-cell">
                                <!-- <p-tableHeaderCheckbox disabled="true"></p-tableHeaderCheckbox> -->
                            </th>
                            <th>
                                Task
                                <p-columnFilter field="representative" matchMode="in" display="menu"
                                    [showMatchModes]="false" [showOperator]="false" [showAddButton]="false"
                                    class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                            [options]="this.tasksSelectItem" [filter]="true"
                                            (onChange)="filter($event.value)">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th>
                                Start Time
                            </th>
                            <th>
                                Calculated Time
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-item let-rowData let-ri="rowIndex">
                        <tr data-id="row-{{ item.uniqueid }}">
                            <td class="select-cell">
                                <div>
                                    <p-tableCheckbox [value]="item"
                                        [disabled]="timerCbx || item.Status > 1"></p-tableCheckbox>
                                </div>
                                <!-- <div *ngIf="item.Status > 1" class="text-center w-100" [title]="item.StatusText">
                            </div> -->
                            </td>
                            <td>
                                {{ item?.taskdisplay }}
                            </td>
                            <td>
                                {{ item?.starttime | date:'medium' }}
                            </td>
                            <td>
                                <button *ngIf="item.starttime != null && calculatedTime == null" pButton type="button"
                                    class="p-button-link" label="View calculated time"
                                    (click)="viewCalculatedTimeClicked(item)"></button>
                                <span *ngIf="calculatedTime != null">
                                    {{ item.CalculatedTime }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <p-accordionTab [selected]="true"
                [header]="(showHistory == true) ? 'Timer History' : 'Current Day Timer Activity'">
                <p-toolbar>
                    <div class="flex items-center">
                        <p-checkbox #ShowHistoryCbx class="ef-checkbox" binary="true" data-toggle="tooltip"
                            data-placement="top" title="Show records of past timers" [(ngModel)]="showHistory"
                            [disabled]="!stopTimerDisabled"
                            (onChange)="showHistoryCheckboxChanged($event)"></p-checkbox>
                        <label for="ShowHistoryCbx" class="ml-2">Show Timer History</label>
                    </div>
                    <p-floatLabel variant="on">
                        <p-datepicker *ngIf="showHistory" [monthNavigator]="true" [yearNavigator]="true"
                            yearRange="2010:2030" appendTo="body" [showIcon]="true" id="range" selectionMode="range"
                            [(ngModel)]="dateRange" (onSelect)="historyDatesSelected($event)">
                        </p-datepicker>
                        <label *ngIf="showHistory" for="range" class="ml-2">Date Range</label>
                    </p-floatLabel>

                </p-toolbar>

                <p-table stripedRows #TimerHistoryTable scrollDirection="both" [scrollable]="true"
                    [style]="{ 'max-width': '100%', 'scrollHeight':  (showHistory === true) ? '63vh' : '20vh'}"
                    [value]="history" dataKey="uniqueid" editMode="row" (onEditInit)="onEditInit($event)"
                    (onRowEditSave)="onRowEditSave($event)">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="17" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span *ngIf="showHistory"> Choose a date range to view history. </span>
                                    <span *ngIf="!showHistory"> No Data Available. </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th class="edit-cell">
                            </th>
                            <th>
                                Task
                            </th>
                            <th>
                                Start Time
                            </th>
                            <th>
                                Stop Time
                            </th>
                            <th *ngIf="showHistory">
                                Calculated Hours
                            </th>
                            <th *ngIf="showHistory">
                                Daily Audit Note
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-edit="editing" let-item let-rowData let-ri="rowIndex">
                        <tr [pEditableRow]="item" data-id="row-{{ item.uniqueid }}">
                            <td class="edit-cell" [title]="rowData.StatusText">
                                <button
                                    *ngIf="showHistory == true && !editing && (!editing?.uniqueid || editing?.uniqueid == item?.uniqueid) && item?.status<=1 && !item.readonly"
                                    pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                    (click)="onRowEditInit(item)" class="p-button-rounded p-button-text"
                                    title="Edit"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                    (click)="onRowEditSave(item)"
                                    class="p-button-rounded p-button-text p-button-success"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                    (click)="onRowEditCancel(item)"
                                    class="p-button-rounded p-button-text p-button-danger"></button>
                            </td>
                            <td>
                                {{ item.taskdisplay }}
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-datepicker [(ngModel)]="histStartTime" [readonlyInput]="true"
                                            [maxDate]="histEndTime" [timeOnly]="true" [hourFormat]="12"
                                            inputId="timeonly" appendTo="body"></p-datepicker>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item.starttime | date:'medium' }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <p-datepicker [(ngModel)]="histEndTime" [readonlyInput]="true"
                                            [minDate]="histStartTime" [timeOnly]="true" [hourFormat]="12"
                                            inputId="timeonly" appendTo="body"></p-datepicker>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item.stoptime | date:'medium' }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="showHistory">
                                {{ item.calculatedhours }}
                            </td>
                            <td *ngIf="showHistory">
                                {{ item.timecomment }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
        </p-accordion>

    </div>
</div>
